export const BUDGET_ID = "budgetId";
export const FINANCIAL_YEAR = "year";
export const GL_MASTER_ID = "glMasterId";
export const TRANSACTION_RATE = "budgetTransactionRate";
export const BUDGET_QTY = "budgetedQuantity";
export const TOLERANCE = "tolerance";
export const YEARLY_AMT = "budgetYearlyAmt";
export const AUTO_APPROVAL = "autoApproval";
export const AUTO_APPROVAL_LEVEL = "autoApprovalLevel";
export const MONTHLY_DISTRIBUTION = "monthlyDistribution";

export const autoApprovalLevelOptions = [
  {
    label: "Yearly",
    value: "YEARLY",
  },
  {
    label: "Monthly",
    value: "MONTHLY",
  },
  {
    label: "Transaction",
    value: "TRANSACTION",
  },
];
